// ui action

export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const HIDE_FOOTER = 'HIDE_FOOTER';
export const SHOW_FOOTER = 'SHOW_FOOTER';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
// SignIn / SignUp Page
// Authentication

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_ALERT = 'USER_LOGOUT_ALERT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';

export const USER_SIGN_UP_SUCCESS = 'USER_SIGN_UP_FAIL';
export const USER_SIGN_UP_FAIL = 'USER_SIGN_UP_FAIL';

// USER PROFILE
export const GET_USER_PROFILE_LOADING = 'GET_USER_PROFILE_LOADING';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_ERROR = 'GET_USER_PROFILE_ERROR';

export const USER_PROFILE_UPDATE_LOADING = 'GET_USER_PROFILE_LOADING';
export const USER_PROFILE_UPDATE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const USER_PROFILE_UPDATE_ERROR = 'GET_USER_PROFILE_ERROR';

// Home Page
// Get movie list action
// SECTION 1-2 - CAROUSEL - MOVIE LIST
export const GET_MOVIE_LIST_LOADING = 'GET_MOVIE_LIST_LOADING';
export const GET_MOVIE_LIST_SUCCESS = 'GET_MOVIE_LIST_SUCCESS';
export const GET_MOVIE_LIST_ERROR = 'GET_MOVIE_LIST_ERROR';

// SECTION 3 - HOME BOOKING SECTION
export const GET_CINEPLEX_LOGO_LOADING = 'GET_CINEPLEX_LOGO_LOADING';
export const GET_CINEPLEX_LOGO_SUCCESS = 'GET_CINEPLEX_LOGO_SUCCESS';
export const GET_CINEPLEX_LOGO_ERROR = 'GET_CINEPLEX_LOGO_ERROR';
export const GET_MOVIE_BY_CINEPLEX_LOADING = 'GET_MOVIE_BY_CINEPLEX_LOADING';
export const GET_MOVIE_BY_CINEPLEX_SUCCESS = 'GET_MOVIE_BY_CINEPLEX_SUCCESS';
export const GET_MOVIE_BY_CINEPLEX_ERROR = 'GET_MOVIE_BY_CINEPLEX_ERROR';
export const IS_SCHEDULE_EMPTY = 'IS_SCHEDULE_EMPTY';

// SECTION 4 - NEWS SECTION
export const GET_NEWS_LOADING = 'GET_NEWS_LOADING';
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS';
export const GET_NEWS_ERROR = 'GET_NEWS_ERROR';

// MovieDetail Page
// Get movie detail  action_

export const GET_MOVIE_DETAIL_LOADING = 'GET_MOVIE_DETAIL_LOADING';
export const GET_MOVIE_DETAIL_SUCCESS = 'GET_MOVIE_DETAIL_SUCCESS';
export const GET_MOVIE_DETAIL_ERROR = 'GET_MOVIE_DETAIL_ERROR';

// Get Cinema list action
export const GET_CINEMA_LIST = 'GET_CINEMA_LIST';

// Booking Page

export const CHOOSING_SEAT = 'CHOOSING_SEAT';
export const USER_BOOKING_SUCCESS = ' USER_BOOKING_SUCCESS';
export const USER_BOOKING_WARNING = ' USER_BOOKING_WARNING';
export const USER_BOOKING_FAIL = ' USER_BOOKING_FAIL';
export const RESET__AMOUNT = ' RESET__AMOUNT';
export const REQUIRE__CHOOSINGSEAT = ' REQUIRE__CHOOSINGSEAT';
// Cineflex phòng vé
export const GET_CINE_ROOM_LOADING = ' GET_CINE_ROOM_LOADING';
export const GET_CINE_ROOM_SUCCESS = ' GET_CINE_ROOM_SUCCESS';
export const GET_CINE_ROOM_ERROR = ' GET_CINE_ROOM_ERROR';
